import React from 'react';
import { Button, Result } from 'antd';
import { useNavigate } from "react-router-dom";

const SomethingWentWrong = () => {
  const navigate = useNavigate();
  const redirectTo = "/";

  return(
    <Result
    status="500"
    title="500"
    subTitle="Sorry, something went wrong."
    extra={<Button type="primary" onClick={() => navigate(redirectTo)} >Back To HomePage</Button>}
  />
  )
  
};
export default SomethingWentWrong;